var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLogFiles = function SvgIconLogFiles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 54.66,
    y1: 484.44,
    x2: 442.85,
    y2: 86.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -58.33,
    y1: 374.23,
    x2: 329.86,
    y2: -23.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -37.5,
    y1: 394.54,
    x2: 350.69,
    y2: -3.44,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 4.68,
    y1: 435.68,
    x2: 392.87,
    y2: 37.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 25.5,
    y1: 456,
    x2: 413.7,
    y2: 58.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 46.33,
    y1: 476.31,
    x2: 434.52,
    y2: 78.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 120.54,
    y1: 548.69,
    x2: 508.73,
    y2: 150.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 141.36,
    y1: 569.01,
    x2: 529.56,
    y2: 171.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 162.19,
    y1: 589.32,
    x2: 550.38,
    y2: 191.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 183.02,
    y1: 609.64,
    x2: 571.21,
    y2: 211.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 203.84,
    y1: 629.95,
    x2: 592.04,
    y2: 231.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 44.75,
    y1: 474.78,
    x2: 432.95,
    y2: 76.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 8.46,
    y1: 439.37,
    x2: 396.65,
    y2: 41.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 87.46,
    y1: 516.43,
    x2: 475.65,
    y2: 118.45,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M481.21,80.25c-.08-.18-.17-.35-.28-.52-1.21-2.66-2.88-5.09-4.93-7.17L410.78,7.33c-2.08-2.05-4.51-3.73-7.17-4.93-.16-.1-.34-.2-.52-.28C399.94.73,396.53,0,393.08,0H116.67C98.26,0,83.33,14.92,83.33,33.33v233.33h-50c-9.2,0-16.67,7.46-16.67,16.67v150c0,9.2,7.46,16.67,16.67,16.67h50v16.67c0,18.41,14.92,33.33,33.33,33.33h333.33c18.41,0,33.33-14.92,33.33-33.33V90.25c0-3.44-.73-6.85-2.12-10ZM408.33,28.45l46.55,46.55h-22.55c-13.25-.01-23.99-10.75-24-24v-22.55ZM33.33,433.33v-150h266.67v150H33.33ZM466.67,466.67c0,9.2-7.46,16.67-16.67,16.67H116.67c-9.2,0-16.67-7.46-16.67-16.67v-16.67h200c9.2,0,16.67-7.46,16.67-16.67v-150c0-9.2-7.46-16.67-16.67-16.67H100V33.33c0-9.2,7.46-16.67,16.67-16.67h275v34.33c.02,22.45,18.22,40.64,40.67,40.67h34.33v375Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141.67,75h200c4.6,0,8.33-3.73,8.33-8.33s-3.73-8.33-8.33-8.33h-200c-4.6,0-8.33,3.73-8.33,8.33s3.73,8.33,8.33,8.33Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M141.67,116.67h200c4.6,0,8.33-3.73,8.33-8.33s-3.73-8.33-8.33-8.33h-200c-4.6,0-8.33,3.73-8.33,8.33s3.73,8.33,8.33,8.33Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M425,141.67H141.67c-4.6,0-8.33,3.73-8.33,8.33s3.73,8.33,8.33,8.33h283.33c4.6,0,8.33-3.73,8.33-8.33s-3.73-8.33-8.33-8.33Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M425,183.33H141.67c-4.6,0-8.33,3.73-8.33,8.33s3.73,8.33,8.33,8.33h283.33c4.6,0,8.33-3.73,8.33-8.33s-3.73-8.33-8.33-8.33Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M425,225H141.67c-4.6,0-8.33,3.73-8.33,8.33s3.73,8.33,8.33,8.33h283.33c4.6,0,8.33-3.73,8.33-8.33s-3.73-8.33-8.33-8.33Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M425,266.67h-75c-4.6,0-8.33,3.73-8.33,8.33s3.73,8.33,8.33,8.33h75c4.6,0,8.33-3.73,8.33-8.33s-3.73-8.33-8.33-8.33Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M425,308.33h-75c-4.6,0-8.33,3.73-8.33,8.33s3.73,8.33,8.33,8.33h75c4.6,0,8.33-3.73,8.33-8.33s-3.73-8.33-8.33-8.33Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M425,350h-75c-4.6,0-8.33,3.73-8.33,8.33s3.73,8.33,8.33,8.33h75c4.6,0,8.33-3.73,8.33-8.33s-3.73-8.33-8.33-8.33Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M425,391.67h-75c-4.6,0-8.33,3.73-8.33,8.33s3.73,8.33,8.33,8.33h75c4.6,0,8.33-3.73,8.33-8.33s-3.73-8.33-8.33-8.33Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M425,433.33h-75c-4.6,0-8.33,3.73-8.33,8.33s3.73,8.33,8.33,8.33h75c4.6,0,8.33-3.73,8.33-8.33s-3.73-8.33-8.33-8.33Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M158.33,308.33c-18.41,0-33.33,14.92-33.33,33.33v33.33c0,18.41,14.92,33.33,33.33,33.33s33.33-14.92,33.33-33.33v-33.33c0-18.41-14.92-33.33-33.33-33.33ZM175,375c0,9.2-7.46,16.67-16.67,16.67s-16.67-7.46-16.67-16.67v-33.33c0-9.2,7.46-16.67,16.67-16.67s16.67,7.46,16.67,16.67v33.33Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.33,391.67h-33.33v-75c0-4.6-3.73-8.33-8.33-8.33s-8.33,3.73-8.33,8.33v75c0,9.2,7.46,16.67,16.67,16.67h33.33c4.6,0,8.33-3.73,8.33-8.33s-3.73-8.33-8.33-8.33Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M266.67,358.33h-16.67c-4.6,0-8.33,3.73-8.33,8.33s3.73,8.33,8.33,8.33h8.33c0,9.2-7.46,16.67-16.67,16.67s-16.67-7.46-16.67-16.67v-33.33c-.02-9.2,7.43-16.68,16.63-16.7,7.09-.02,13.41,4.46,15.76,11.14,1.71,4.27,6.57,6.34,10.84,4.63,4.02-1.61,6.13-6.04,4.86-10.18-6.14-17.36-25.19-26.45-42.54-20.31-13.31,4.71-22.21,17.3-22.22,31.42v33.33c0,18.41,14.92,33.33,33.33,33.33s33.33-14.92,33.33-33.33v-8.33c0-4.6-3.73-8.33-8.33-8.33Z"
  })));
};
export default SvgIconLogFiles;